module.exports = __webpack_public_path__ + "static/media/shop_type_1.0d5e17c9.png";